import React from 'react'
import {Box, Divider, Typography} from '@mui/material';
import { Footer, Hero, SectionTitle } from '../components';

//assets

import { AboutCommitment, ContactInfo } from '../containers';
import { AboutHero, AboutPurpose } from '../containers/About';


const About = ({id}) => {
  
  


  return (
    <Box>
      <Hero />
    
        <Box
          sx={{
            background:'linear-gradient(to right, #A6A6A6, #fefefe)',
            display:'flex',
            flexDirection:'column',
            width:'100%',
            justifyContent:'center'
          }}
        >
            <SectionTitle 
              firstTitleWord='About'
              secondTitleWord='Pangu'
              textStyle={{
              }}
              sx={{
                '@media screen and (max-width:762px)' :{
                  width:'100%'
                }
              }}
            />

          <Box>
            <Typography
              variant='h1'
              sx={{
                fontFamily:'var(--title-font)',
                fontSize:'2.5rem',
                textAlign:'center',
                fontWeight:'500',
                textTransform:'uppercase',
                '@media screen and (max-width: 762px)':{
                  paddingX:'1rem'
                }
              }}
            >Turning Ideas into exceptional spaces</Typography>
          </Box>

          <Box
            sx={{
              width:'80%',
              justifyContent:'center',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              padding:'2rem',
              marginX:'auto',
              '@media screen and (max-width: 762px)':{
                  padding:'1rem'
                }
            }}
          >
          <Typography
              sx={{
                fontFamily: 'Gotham',
                fontSize: '1.2rem',
                '@media screen and (max-width: 762px)':{
                  fontSize:'1rem',
                }
              }}
            >
              We redefine full-service construction by combining expertise, precision, and creativity across all project types&#8212;no matter the size, complexity, or delivery model. Our approach is tailored to fit your project's unique needs, ensuring maximum value without compromising quality.
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Gotham',
                fontSize: '1.2rem',
                marginTop: '1rem', // Adds space between paragraphs
                '@media screen and (max-width: 762px)':{
                  fontSize:'1rem',
                }
              }}
            >
              At Pangu, we're flexible, forward-thinking, and dedicated to your success. By blending innovative solutions with expert craftsmanship, we make your vision our mission&#8212;and deliver results.
            </Typography>
          </Box>
          
          <Divider 
            sx={{
              borderWidth:'0.01rem'
            }}
          />
          <Box
            sx={{
              background: `
              linear-gradient(135deg, #e0e0e0 25%, transparent 25%) -10px 0,
              linear-gradient(225deg, #e0e0e0 25%, transparent 25%) -10px 0,
              linear-gradient(315deg, #e0e0e0 25%, transparent 25%),
              linear-gradient(45deg, #e0e0e0 25%, transparent 25%)
            `
              
            }}
          >
            <AboutPurpose />
          </Box>
          <Divider 
            sx={{
              borderWidth:'0.01rem'
            }}
          />
        </Box>
        
        <Box
            sx={{
              paddingY:'2rem',
              background:'linear-gradient(to right, #A6A6A6, #fefefe)',
              display:'flex',
              flexDirection:'column',
              width:'100%',
              justifyContent:'center'
            }}
        >
          <SectionTitle 
            firstTitleWord='Our'
            secondTitleWord='Purpose'
            sx={{
              width:'100%'
            }}
          />

            <Box
              sx={{
                width:'70%',
                display:'flex',
                flexDirection:'column',
                justifyContent:'center',
                alignItems:'center',
                marginX:'auto'
              }}
            >
              <Typography
                sx={{
                  fontSize:'1.2rem',
                  fontFamily:'Gotham',
                  textTransform:'',
                  '@media screen and (max-width: 762px)':{
                    fontSize:'1rem'
                  }
                }}
              >
                At Pangu enterprises, we set the standard for Excellence by integratng Sustainability, Innovation, and Integrity into every project.
              </Typography><br />
              <Typography
                sx={{
                  fontSize:'1.2rem',
                  fontFamily:'Gotham',
                  textTransform:'',
                  '@media screen and (max-width: 762px)':{
                    fontSize:'1rem'
                  }
                }}
              >
                Our commitment goes beyond construction&#8212;we prioritize responsible building practices, inclusivity, and long-term impact.
              </Typography><br />
              <Typography
                sx={{
                  fontSize:'1.2rem',
                  fontFamily:'Gotham',
                  textTransform:'',
                  '@media screen and (max-width: 762px)':{
                    fontSize:'1rem'
                  }
                }}
              >
                By collaborating closely with our Clients, Partners, and Communities, we create spaces that inspire, endure, and contribute to a better future. <br /><br />With Pangu, every project is a step toward progress, driven by quality, sustainability, and a shared vision for success.
              </Typography>
            </Box>
          </Box>
          <Divider 
            sx={{
              borderWidth:'0.01rem',
            }}
          />
        <AboutCommitment />
        {/* <ContactInfo 
          sx={{
            background:'linear-gradient(to right, #A6A6A6, #fefefe)',
          }}
        /> */}
        <Footer />

    </Box>
  )
}

export default About